export const END_POINT_AUTH_TOKEN = `/oauth/token`;
export const END_POINT_ADMIN = `/admins`;
export const END_POINT_ADMIN_LOGIN = `/admins/login`;
export const END_POINT_VEHICLE = `/vehicles`;
